module.exports = __webpack_public_path__ + "static/tribute-labs-d0428a7617ed112e70dbf71f5b7875c6.png";